/*
 * @Author: Han
 * @Date: 2022-05-10 18:00:27
 * @LastEditors: Han
 * @LastEditTime: 2022-05-11 10:19:14
 * @FilePath: \czssj-h5\h5\src\http\moudules\perfectRegis.js
 */
import axios from '../axios'

export const getSchoolList = (data) => {
  return axios({
    url: '/zyc/userSchool/querySchoolList',
    method: 'get',
    data
  })
}

export const createUser = (data) => {
  return axios({
    url: '/applet/junior/createUser',
    method: 'post',
    data
  })
}

export const commitFk = (data) => {
  return axios({
    url: '/applet/mind_camp_feedback/commit',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/perfectRegis.js